<template>
  <div>
    <div class="decorative-divider"></div>

    <div class="bank-details">
      <h2>Payment details</h2>

      <p><strong>Pickstar Pty Ltd</strong></p>
      <div v-if="bookingRegion === 'gb'">
        <p>Waterhouse Business Centre</p>
        <p>Chelmsford, Essex. CM1 2QE</p>
      </div>
      <div v-else>
        <p>Level 4, 33 King William Street</p>
        <p>Adelaide, 5000</p>
      </div>
    </div>

    <div class="text-center">
      <ladda-button
        class="btn btn-payment"
        type="submit"
        :click="handlePaymentSentCallback"
        v-if="selectedPaymentAmountsAreNotSent"
      >
        <i class="fa fa-send"></i>
        Payment Sent
      </ladda-button>
    </div>

    <ul class="large-checklist" v-if="$userIsAdmin">
      <li>
        <div class="checkbox checkbox-primary">
          <input
            type="checkbox"
            id="checkbox_payment_received"
            :disabled="processingPaymentsReceived"
            @click="handlePaymentReceivedCallback"
          />
          <label for="checkbox_payment_received">
            Payment Received
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { helpers } from 'mixins/bookings'
import { notify } from 'utils'

export default {
  mixins: [helpers],

  props: {
    paymentIds: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      processingPaymentsReceived: false
    }
  },

  computed: {
    ...mapState('booking', ['booking']),

    bookingRegion () {
      return this.booking.region.shortname
    },

    /**
     * Determines if we have selected both payment amounts.
     *
     * @return bool
     */
    selectedBothPaymentAmounts () {
      return this.paymentIds.length === 2
    },

    /**
     * Determines if the payment amounts selected are not sent.
     *
     * @return bool
     */
    selectedPaymentAmountsAreNotSent () {
      return this.paymentIds.some(id => {
        if (
          this.bookingPaymentFull &&
          parseInt(id) === this.bookingPaymentFull.id &&
          this.bookingPaymentFullIsUnpaid
        ) {
          return true
        }

        if (
          this.bookingPaymentDeposit &&
          parseInt(id) === this.bookingPaymentDeposit.id &&
          this.bookingPaymentDepositIsUnpaid
        ) {
          return true
        }

        if (
          this.bookingPaymentFinal &&
          parseInt(id) === this.bookingPaymentFinal.id &&
          this.bookingPaymentFinalIsUnpaid
        ) {
          return true
        }

        return false
      })
    }
  },

  methods: {
    ...mapActions('payment', ['updatePaymentSent', 'updatePaymentReceived']),
    ...mapActions('booking', ['setBookingProperty']),

    /**
     * Handle marking payments as sent.
     *
     * @return Promise
     */
    handlePaymentSentCallback () {
      const payload = {
        payments: this.paymentIds,
        payment_method: 'cheque'
      }

      return this.updatePaymentSent({
        bookingId: this.booking.id,
        payload
      }).then(response => {
        this.setBookingProperty({ property: 'payments', value: response.data })

        if (this.selectedBothPaymentAmounts) {
          notify.success('Payments were successfully marked as sent.')
        } else {
          notify.success('Payment was successfully marked as sent.')
        }
      })
    },

    /**
     * Handle marking payments as received.
     *
     * This is potentially dangerous as it cannot be undone through UI.
     *
     * @return Promise
     */
    handlePaymentReceivedCallback () {
      if (this.processingPaymentsReceived) {
        return
      }

      this.processingPaymentsReceived = true

      const payload = {
        payments: this.paymentIds,
        payment_method: 'cheque'
      }

      return this.updatePaymentReceived({
        bookingId: this.booking.id,
        payload
      }).then(response => {
        this.processingPaymentsReceived = false

        this.setBookingProperty({ property: 'payments', value: response.data })
      })
    }
  }
}
</script>
